// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OB4v","rootMobile":"styles_rootMobile__2pmUy"};